var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timmer"},[_c('label',{staticClass:"is-size-3-desktop",style:(_vm.quizMessage)},[_vm._v(_vm._s(_vm.formattedElapsedTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }